/* eslint-disable no-console */
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { Header, TopBanner, WorkerDailyDues } from '@/modules/Settlements';
import { useGetWorkerSettlementDetails } from '@/modules/Settlements/apiHooks';
import { Loading } from '@/shared/components/atoms';
import { EmptyCard } from '@/shared/components/molecules';
import { useStore } from '@/shared/hooks/context/createGenericContext';

function WorkerSettlementDetails() {
  const { t } = useTranslation('common');
  const { query } = useRouter();

  const { id } = query;
  const [selectedAsset] = useStore((store) => store?.asset);
  const { data, isLoading } = useGetWorkerSettlementDetails({
    entityId: selectedAsset?.id,
    id: id?.toString(),
  });

  if (isLoading) {
    return <Loading />;
  }
  if (!data) {
    return <EmptyCard variant='text' message={t('no-data')} />;
  }

  return (
    <div className='flex flex-col gap-24'>
      <Header status={data?.status} />
      <TopBanner data={data} />
      <WorkerDailyDues
        days={data.days ?? []}
        endDate={data.endDate}
        startDate={data.startDate}
      />
    </div>
  );
}
export { WorkerSettlementDetails };
